// Barrel for offline-recording Jotai atoms.
// Scaffolded under APP-6185; sync atoms added under APP-6190.
export {
  cachedLastUsedRecorderSettingsAtom,
  getCachedLastUsedRecorderSettings,
  setCachedLastUsedRecorderSettings,
  type CachedRecorderSettings,
} from './cached-recorder-settings';
export {
  OFFLINE_NOTE_FAILED_DISMISSED_SESSION_IDS_STORAGE_KEY,
  OFFLINE_NOTE_FAILED_SESSION_IDS_STORAGE_KEY,
  offlineActiveRecordingAtom,
  offlineActiveRecordingIdAtom,
  offlineBackendUnreachableAtom,
  offlineCapturePausedAtom,
  offlineCaptureRunningAtom,
  offlineConnectivityStateAtom,
  offlineDeletedLocalSessionIdsAtom,
  offlineDismissedSyncedBadgeIdsAtom,
  offlineFailedCountAtom,
  offlineLocalSessionsAtom,
  offlineNoteFailedDismissedSessionIdsAtom,
  offlineNoteFailedSessionIdsAtom,
  offlinePendingCountAtom,
  offlinePendingServerDeleteIdsAtom,
  offlineQueueCountAtom,
  offlineReadyToSyncAtom,
  offlineSyncPausedAtom,
  offlineSyncQueueAtom,
  readOfflinePendingServerDeleteIds,
  useOfflinePendingServerDeleteIds,
  type OfflineLocalSessionListItem,
} from './sync';

// Boot-time availability of the local offline database.
export {
  OFFLINE_SCHEMA_AHEAD_OF_BUILD_CODE,
  offlineStorageAvailabilityAtom,
  toOfflineStorageAvailability,
  type OfflineStorageAvailability,
  type OfflineStorageUnavailableReason,
} from './availability';

// Typed patient link captured offline (APP-6501).
export {
  offlinePatientLinkAtomFamily,
  offlinePatientLinksBySessionIdAtom,
} from './patient-link';

// Deferred transcribe-mode choices for server sessions toggled offline (APP-7994).
export { pendingTranscribeModeBySessionIdAtom } from './pending-transcribe-mode';

// Deferred consent answers for server sessions answered while the backend was
// unreachable. Same holding pattern as the transcribe-mode store above, for the
// same class of session — one that has a server record but no offline row, so
// it never rides the sync-time PATCH.
export { pendingConsentBySessionIdAtom } from './pending-consent';
export {
  abortPendingConsentReplay,
  finishPendingConsentReplay,
  startPendingConsentReplay,
} from './pending-consent-replay-abort';

// The user's DEFAULT transcribe mode, chosen offline and awaiting its /user
// PATCH. Distinct from the per-session store above: this one feeds the offline
// create args, so it decides the mode of sessions not yet created.
export {
  getPendingUserDefaultTranscribeMode,
  pendingUserDefaultTranscribeModeAtom,
  setPendingUserDefaultTranscribeMode,
} from './pending-user-default-transcribe-mode';
